"use strict";
define(
'stores/assignments',[
	"jquery",
	"stores/store",
	"constants/actiontypes",
	"xregexp"
],
function ($, StoreBase, Constants, XRegExp)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);
		
		// Setup the instance
		this.assignments = null;
		this.registerDispatchListener(function (action) {
			var self = this;
			switch(action.actionType) {
				case Constants.TRUNCATE_ASSIGNMENT:
					this.assignments = null;
					break;
				case Constants.CREATED_ASSIGNMENT:
					if(!this.assignments)
						this.assignments = {};

					this.clearAllSectionCache();
					if (Array.isArray(action.data)) {
						_.each(action.data, function (data, index, list) {
							this.addAssignment(data);
							
						}, this);
					} else {
						this.addAssignment(action.data);
					}
					break;
				case Constants.UPDATED_ASSIGNMENT:
					this.clearAllSectionCache();
					if(this.assignments[action.assignmentId]) {
						_.each(action.data, function(value, key) {
							self.assignments[action.assignmentId][key] = value;
						});
					}
					else {
						console.log("Error - Assignment doesn't exist.");
					}

					break;
				case Constants.DELETED_ASSIGNMENT:
					this.clearAllSectionCache();
					if(this.assignments[action.assignmentId]) {
						delete this.assignments[action.assignmentId];
					}
					break;
				case Constants.CLEAR_SECTION_CACHE:
					this.clearSectionCache(action.data.section_guid);
					break;
				case Constants.PULLING_ALL_ASSIGNMENTS:
					break;
			}
			this.event.emit("change");
		}.bind(this));
	}

	Store.prototype.pullFromClass = function (id)
	{
		var Actions = require("shared/connect-to-actions");
		this.assignments = {};
		Actions.assignments.pullFromClass(id);
	}

	Store.prototype.pullQuestions = function (guid)
	{
		if(this.assignments[guid.toLowerCase()] && this.assignments[guid.toLowerCase()].questions) {
			return true;
		}
		if(!this.assignments[guid.toLowerCase()]){
			return false;
		}
		var Actions = require("shared/connect-to-actions");
		Actions.assignments.pullQuestions(guid);
		return false;
	};

	Store.prototype.addAssignment = function(data)
	{
		data.start_at = new Date(data.start_at);
		data.created_on = new Date(data.created_on);
		data.due_at = new Date(data.due_at);
		this.assignments[data.id.toLowerCase()] = data;
	};

	Store.prototype.get = function(id)
	{
		if(!this.assignments)
			return null;

		return this.assignments[id];
	}

	Store.prototype.getAll = function (filterOptions, sortOptions)
	{
		if(!this.assignments)
			return null;

		var assignments;
		if(filterOptions) {
			var keywordRegExp = null;
			
			if(filterOptions.keyword && filterOptions.keyword.trim().length >= 3) {
				// Trim all spaces from beginning and ending
				var keyword = filterOptions.keyword.trim();

				// Make a regular expression to allow all characters, numerics, and spaces
				var allowCharacterSets = XRegExp("[^\\pL\\s\\d]+", "g");

				// Replace all special characters as nothing and space as OR("|")
				keyword = XRegExp.replace(keyword, allowCharacterSets, "");
				keyword = keyword.trim().replace(/\s+/g, "|");

				// Make a regular expression to search with keyword
				keywordRegExp = new RegExp(keyword, "i");
			}

			assignments = _.filter(this.assignments, function(assignment) {
				if(filterOptions.section_guid && assignment.section_guid != filterOptions.section_guid) {
					return;
				}
				if(keywordRegExp && !keywordRegExp.test(assignment.title)) {
					return;
				}

				return assignment;
			});
		}
		else {
			assignments = _.map(this.assignments, function(assignment) {
				return assignment;
			});
		}

		if(sortOptions) {
			var sortFunction;
			if(sortOptions.sortColumn == "due_at" || sortOptions.sortColumn == "created_on" || sortOptions.sortColumn == "start_at") {
				sortFunction = function(a, b) {
					var aVal = a[sortOptions.sortColumn];
					var bVal = b[sortOptions.sortColumn];

					var result = aVal > bVal ? 1 : -1;

					if(sortOptions.sortAsc)
						result *= -1;

					return result;
				};
			}
			else {
				sortFunction = function(a, b) {
					var aVal = a[sortOptions.sortColumn];
					var bVal = b[sortOptions.sortColumn];

					var result = aVal.localeCompare(bVal);

					if(sortOptions.sortAsc)
						result *= -1;

					return result;
				}
			}

			assignments.sort(sortFunction);
		}
		
		return assignments;
	}

	Store.prototype.hasAssignment = function(id)
	{
		return (id.toLowerCase() in this.assignments);
	}

	Store.prototype.getAssignment = function(id)
	{
		if(!this.assignments)
			return null;

		return this.assignments[id.toLowerCase()];
	}

	Store.prototype.getAssignments = function(ids)
	{
		var filtered = [];
		var self = this;
		ids.forEach(function(id) {
			if(id in self.assignments) {
				filtered.push(self.assignments[id]);
			}
		});

		return filtered;
	}

	Store.prototype.getAssignmentOrPull = function(id)
	{
		if(!this.assignments || !this.assignments[id.toLowerCase()]) {
			var Actions = require("shared/connect-to-actions");
			Actions.assignments.pullByGuid(id);
			return null;
		}
		
		return this.assignments[id.toLowerCase()];
	}

	Store.prototype.clearAllSectionCache = function(){
		if(this.sectionCache)
			this.sectionCache = {};
	};

	Store.prototype.clearSectionCache = function(sectionId){
		delete this.sectionCache[sectionId]
	};

	return Store;
});

